import { useToast } from '../../Toast';

export const useNotifications = () => {
  const toast = useToast();

  const showNotification = (message, type = 'success') => {
    if (type === 'error') toast.error(message);
    else toast.success(message);
  };

  return { showNotification };
};
